import { configureStore } from '@reduxjs/toolkit';
import mealReducer from '../Features/mealSlice';

const store = configureStore({
  reducer: {
    mealBook: mealReducer, // mealBook state is handled by mealReducer
  },
});

export default store;
